import React, { useContext, useState } from "react";
import { Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { BoletimContext } from "../../../context/BoletimContext";


import CabecalhoBoletim from "../components/CabecalhoBoletim";
import FormHeader from "./compoments/FormHeader";
import NavPage from "../../../components/NavPage";
import { validateCoordinatePair } from "./coordinateValidation";
import { validateBoletim } from '../../../Utils/boletimValidation';

import "./styles/estilo-dark.css";

const Header = ({municipio})=>{
    const {boletim, setBoletim} = useContext(BoletimContext)
    const navigate = useNavigate();
    const [validationMessage, setValidationMessage] = useState("");
    const [coordinateErrors, setCoordinateErrors] = useState({});

    const validateOccurrence = () => {
        const number = String(boletim.numero || "").trim();
        const errors = validateBoletim({ ...boletim, municipio: boletim.municipio || municipio });
        setCoordinateErrors(errors);
        if (Object.keys(errors).length) {
            setValidationMessage("Corrija os campos destacados para continuar.");
            const ids = { numero: 'boletim-numero', data: 'boletim-data', horario: 'boletim-horario', natureza: 'natureza-ocorrencia', latitude: 'latitude', longitude: 'longitude' };
            document.getElementById(ids[Object.keys(errors)[0]])?.focus();
            return;
        }
        const coordenadas = validateCoordinatePair(boletim.latitude, boletim.longitude);
        setValidationMessage("");
        setBoletim((current) => ({
            ...current,
            numero: number,
            latitude: coordenadas.latitude,
            longitude: coordenadas.longitude,
            natureza: String(current.natureza || "").trim(),
        }));
        navigate("../envolvido");
    };

    return(
        <div className="bo-form-root">
            <CabecalhoBoletim texto={"Fato Comunicado"}/>
            {validationMessage && <Alert variant="danger" className="mx-auto" style={{ maxWidth: 920 }}>{validationMessage}</Alert>}
            <FormHeader
                boletim={boletim}
                setBoletim={setBoletim}
                municipio={municipio}
                coordinateErrors={coordinateErrors}
                onFieldChange={() => {
                    setValidationMessage("");
                    setCoordinateErrors({});
                }}
            />
            <NavPage prev="/dashboard" onNext={validateOccurrence}/>

        </div>
    )

    
}

export default Header;
